import React from 'react';

/**
 * DetailView - Right panel that displays details for the active item
 *
 * @param {Object} props
 * @param {Object|null} props.activeItem - Currently active item
 * @param {Function} props.renderDetail - Function to render detail content: (item) => React.Node
 */
export function DetailView({ activeItem, renderDetail }) {
    if (!activeItem) {
        return (
            <div className="border border-gray-300 rounded-lg bg-white flex items-center justify-center p-12">
                <div className="text-center text-gray-500">
                    <div className="text-4xl mb-2">📋</div>
                    <div className="text-sm">Select an item to view details</div>
                </div>
            </div>
        );
    }

    return (
        <div className="border border-gray-300 rounded-lg bg-white">
            <div className="p-6">{renderDetail ? renderDetail(activeItem) : <DefaultDetail item={activeItem} />}</div>
        </div>
    );
}

/**
 * DefaultDetail - Fallback detail renderer if no custom renderer provided
 */
function DefaultDetail({ item }) {
    return (
        <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{item.name || item.title || 'Untitled'}</h3>
            {item.description && <p className="text-gray-600">{item.description}</p>}
            <div className="pt-4 border-t border-gray-300">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Item Details</h4>
                <pre className="text-xs text-gray-600 bg-gray-50 p-3 rounded overflow-auto">
                    {JSON.stringify(item, null, 2)}
                </pre>
            </div>
        </div>
    );
}
